// src/components/panels/PurchasePanel.js
import React from 'react';

const PurchasePanel = ({
    bulkOPDiscount,
    setBulkOPDiscount,
    handleBulkUpdateOPDiscount,
    associatedCosts,
    handleAssociatedCostChange,
    costDistribution,
    setCostDistribution,
    totals,
    formatCurrencyDynamic,
    areButtonsDisabled
}) => {
    return (
        <>
            <div className="panel associated-costs-panel">
                <h3 className="panel-title">Associated Costs</h3>
                <div className="panel-content">
                    <div className="tool-group">
                        <strong>OP Disc. %:</strong>
                        <input type="number" value={bulkOPDiscount} onChange={(e) => setBulkOPDiscount(e.target.value)} placeholder="New discount" />
                        <button onClick={handleBulkUpdateOPDiscount} disabled={areButtonsDisabled} className="btn-secondary">Set</button>
                    </div>
                    <hr className="tool-separator" />
                    {Object.keys(associatedCosts).map(key => (
                        <div className="tool-group" key={key}>
                            <strong>{key}:</strong>
                            <input type="number" placeholder="Amount in EUR" value={associatedCosts[key]} onChange={(e) => handleAssociatedCostChange(key, e.target.value)} />
                        </div>
                    ))}
                    <hr className="tool-separator" />
                    <div className="tool-group">
                         <strong>Distribution:</strong>
                         <div className="distribution-options">
                            <label><input type="radio" value="proportional" checked={costDistribution === 'proportional'} onChange={(e) => setCostDistribution(e.target.value)} /> Proportional</label>
                            <label><input type="radio" value="equal" checked={costDistribution === 'equal'} onChange={(e) => setCostDistribution(e.target.value)} /> Equal</label>
                         </div>
                    </div>
                </div>
            </div>
            <div className="panel sums-panel">
               <h3 className="panel-title">Purchase Sums</h3>
               <div className="panel-content">
                   <table className="totals-table">
                       <tbody>
                           <tr><td>QTY Total</td><td style={{ textAlign: 'right' }}>{totals.totalQuantity.toLocaleString('cs-CZ')} pcs</td></tr>
                           <tr><td>Goods Total</td><td style={{ textAlign: 'right' }}>{formatCurrencyDynamic(totals.totalGoodsEur, 'EUR', 1)}</td></tr>
                           <tr><td>AsCosts Total</td><td style={{ textAlign: 'right' }}>{formatCurrencyDynamic(totals.totalAsCosts, 'EUR', 1)}</td></tr>
                           <tr style={{borderTop: '1px solid #ccc'}}><td style={{ fontWeight: 'bold' }}>OP Total</td><td style={{ textAlign: 'right', fontWeight: 'bold' }}>{formatCurrencyDynamic(totals.totalFinalOPEur, 'EUR', 1)}</td></tr>
                       </tbody>
                   </table>
               </div>
           </div>
        </>
    );
};

export default PurchasePanel;